export const QR_ID = 'qrId';
export const DOCUMENT_TYPE = 'documentType';
